export const driverData = [
  {
    cab_number: "Ram Kumar",
    driver_number: "9876543210",
    phone_number: "Online",
    idle_time: "Primary",
    car_type: "SCO",
    rating: "KA-50-A-6573",
    revenue: "BNC922030082",
    distance: "BNC922030082",
  },

  {
    cab_number: "Ram Kumar",
    driver_number: "9876543210",
    phone_number: "Online",
    idle_time: "Primary",
    car_type: "SCO",
    rating: "KA-50-A-6573",
    revenue: "BNC922030082",
    distance: "BNC922030082",
  },

  {
    cab_number: "Ram Kumar",
    driver_number: "9876543210",
    phone_number: "Online",
    idle_time: "Primary",
    car_type: "SCO",
    rating: "KA-50-A-6573",
    revenue: "BNC922030082",
    distance: "BNC922030082",
  },

  {
    cab_number: "Ram Kumar",
    driver_number: "9876543210",
    phone_number: "Online",
    idle_time: "Primary",
    car_type: "SCO",
    rating: "KA-50-A-6573",
    revenue: "BNC922030082",
    distance: "BNC922030082",
  },

  {
    cab_number: "Ram Kumar",
    driver_number: "9876543210",
    phone_number: "Online",
    idle_time: "Primary",
    car_type: "SCO",
    rating: "KA-50-A-6573",
    revenue: "BNC922030082",
    distance: "BNC922030082",
  },

  {
    cab_number: "Ram Kumar",
    driver_number: "9876543210",
    phone_number: "Online",
    idle_time: "Primary",
    car_type: "SCO",
    rating: "KA-50-A-6573",
    revenue: "BNC922030082",
    distance: "BNC922030082",
  },

  {
    cab_number: "Ram Kumar",
    driver_number: "9876543210",
    phone_number: "Online",
    idle_time: "Primary",
    car_type: "SCO",
    rating: "KA-50-A-6573",
    revenue: "BNC922030082",
    distance: "BNC922030082",
  },

  {
    cab_number: "Ram Kumar",
    driver_number: "9876543210",
    phone_number: "Online",
    idle_time: "Primary",
    car_type: "SCO",
    rating: "KA-50-A-6573",
    revenue: "BNC922030082",
    distance: "BNC922030082",
  },

  {
    cab_number: "Ram Kumar",
    driver_number: "9876543210",
    phone_number: "Online",
    idle_time: "Primary",
    car_type: "SCO",
    rating: "KA-50-A-6573",
    revenue: "BNC922030082",
    distance: "BNC922030082",
  },
  {
    cab_number: "Ram Kumar",
    driver_number: "9876543210",
    phone_number: "Online",
    idle_time: "Primary",
    car_type: "SCO",
    rating: "KA-50-A-6573",
    revenue: "BNC922030082",
    distance: "BNC922030082",
  },
  {
    cab_number: "Ram Kumar",
    driver_number: "9876543210",
    phone_number: "Online",
    idle_time: "Primary",
    car_type: "SCO",
    rating: "KA-50-A-6573",
    revenue: "BNC922030082",
    distance: "BNC922030082",
  },

  {
    cab_number: "Ram Kumar",
    driver_number: "9876543210",
    phone_number: "Online",
    idle_time: "Primary",
    car_type: "SCO",
    rating: "KA-50-A-6573",
    revenue: "BNC922030082",
    distance: "BNC922030082",
  },

  {
    cab_number: "Ram Kumar",
    driver_number: "9876543210",
    phone_number: "Online",
    idle_time: "Primary",
    car_type: "SCO",
    rating: "KA-50-A-6573",
    revenue: "BNC922030082",
    distance: "BNC922030082",
  },

  {
    cab_number: "Ram Kumar",
    driver_number: "9876543210",
    phone_number: "Online",
    idle_time: "Primary",
    car_type: "SCO",
    rating: "KA-50-A-6573",
    revenue: "BNC922030082",
    distance: "BNC922030082",
  },

  {
    cab_number: "Ram Kumar",
    driver_number: "9876543210",
    phone_number: "Online",
    idle_time: "Primary",
    car_type: "SCO",
    rating: "KA-50-A-6573",
    revenue: "BNC922030082",
    distance: "BNC922030082",
  },

  {
    cab_number: "Ram Kumar",
    driver_number: "9876543210",
    phone_number: "Online",
    idle_time: "Primary",
    car_type: "SCO",
    rating: "KA-50-A-6573",
    revenue: "BNC922030082",
    distance: "BNC922030082",
  },

  {
    cab_number: "Ram Kumar",
    driver_number: "9876543210",
    phone_number: "Online",
    idle_time: "Primary",
    car_type: "SCO",
    rating: "KA-50-A-6573",
    revenue: "BNC922030082",
    distance: "BNC922030082",
  },
];

export const driverColumns = [
  {
    name: "CAB #",
    selector: (row) => row["cab_number"],
    sortable: true,
    center: true,
  },
  {
    name: "DRIVER #",
    selector: (row) => row["driver_name"],
    sortable: true,
    center: true,
  },
  {
    name: "PHONE #",
    selector: (row) => row["phone_number"],
    sortable: true,
    center: true,
  },
  {
    name: "IDLE TIME",
    selector: (row) => row["idle_time"],
    sortable: true,
    center: true,
  },
  {
    name: "CAR TYPE",
    selector: (row) => row["car_type"],
    sortable: true,
    center: true,
    // maxWidth:"7vw",
  },
  {
    name: "RATING",
    selector: (row) => row["rating"],
    sortable: true,
    center: true,
    // maxWidth:"7vw",
  },
  {
    name: "REVENUE",
    selector: (row) => row["revenue"],
    sortable: true,
    center: true,
    // width:"100px",
  },
  {
    name: "DISTANCE",
    selector: (row) => row["distance"],
    sortable: true,
    center: true,
  },
  // {
  //   name: "Available",
  //   selector: (row) => row["isAvailable"],
  //   sortable: true,
  //   center: true,
  // },
  {
    name: "",
    selector: (row) => row["action"],
    sortable: true,
    center: true,
    width: "50px",
  },
];
